import React, { useEffect, useState } from "react";
import { useDocumentTitle, useDepartmentUpdatePage } from "../../hooks";
import BackendLayout from "../../layouts/BackendLayout";
import { useSelector, useDispatch } from "react-redux";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import * as ROUTES from "../../constants/routes";
import _ from "lodash";
import {
  ButtonTableEdit,
  FormGroup,
  FormGroupInput,
  FormGroupVerticalInput,
  PageTitle,
  ButtonTableDelete,
  ButtonAdd,
  Label,
  ButtonTableBulkDelete,
  Button,
  CheckboxInput,
  ButtonDPad, RedirectAlert,
} from "../../components";
import { FilterSearch } from "../../components/filter";
import Select2 from "../../components/Select2";
import Table from "../../components/table/Table";
import {
  ArrayUtils,
  SelectUtils,
  errorStatusHandle,
  getInputErrorMessage,
} from "../../utils";
import ExpandableDiv from "../../components/table/ExpandableDiv";
import Pagination from "../../components/Pagination";
import { changeOrder } from "../../utils/common-utils.js";
import Modal from "../../components/modal/Modal";
import {
  clearButtonProcessing,
  setAlertSuccess,
  setButtonProcessing,
} from "../../store/actions";
import { deleteDepartment, submitDepartment } from "../../services";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import PageAlert from "../../components/alerts/PageAlert";
import { useDepartmentUpdatePageSetting } from "../../hooks/DepartmentHook";
import { pushToFirst } from "../../utils/array-utils";
import LoadingSpinner from "../../components/loading/LoadingSpinner.js";
import { USER_SETTING_CATEGORIES } from "../../constants/app";
import { updateUserSetting } from "../../services/user-master/UserSettingServices";
import {
  findNodeByName,
  getSelectOptionsByName,
} from "../../utils/group-tree.js";
import { DEPARTMENT_MASTER_UPDATE_PAGE } from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

const DepartmentUpdate = () => {
  useRedirectPage(DEPARTMENT_MASTER_UPDATE_PAGE);
  useDocumentTitle("部門マスタ更新 - 点検王");
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(ROUTES.DEPARTMENT_MASTER_UPDATE);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);
  const [buttonConfirmId, setButtonConfirmId] = useState("");
  const [reload, setReload] = useState(0);
  const [expanded, setExpanded] = useState(null);
  const [buttonLoading, setButtonLoading] = useState("");
  const DEPARTMENT_SEARCH_BUTTON = "button__search-department";

  const {
    departments,
    page,
    perPage,
    count,
    orderList,
    setDepartments,
    setPage,
    setPerPage,
    setFilters,
    setOrderList,
  } = useDepartmentUpdatePage(reload, buttonLoading);
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  const [groupsOptions, setGroupOptions] = useState({});
  const [filterGroupsOptions, setFilterGroupOptions] = useState({});
  const initDepartmentData = {
    id: null,
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    position: null,
    users: [],
  };
  const [isAddModal, setIsAddModal] = useState(null);
  const [departmentModalData, setDepartmentModalData] =
    useState(initDepartmentData);
  const [formError, setFormError] = useState({});
  const { users, positions, groupTree, filterList, setFilterList } =
    useDepartmentUpdatePageSetting(setFilters);

  useEffect(() => {
    const groupOptions = {
      1: groupTree?.getChildrenSelectOptions(true),
      2:
        groupTree
          ?.findNode(departmentModalData[1])
          ?.getChildrenSelectOptions(true) ?? [],
      3:
        groupTree
          ?.findNode(departmentModalData[2])
          ?.getChildrenSelectOptions(true) ?? [],
      4:
        groupTree
          ?.findNode(departmentModalData[3])
          ?.getChildrenSelectOptions(true) ?? [],
      5:
        groupTree
          ?.findNode(departmentModalData[4])
          ?.getChildrenSelectOptions(true) ?? [],
    };
    setGroupOptions(groupOptions);
  }, [departmentModalData, groupTree]);

  useEffect(() => {
    let group2Parent = filterList[1]?.value
      ? findNodeByName(groupTree, filterList[1]?.value, 1)
      : [groupTree];
    let group3Parent = filterList[2]?.value
      ? findNodeByName(groupTree, filterList[2]?.value, 2)
      : group2Parent;
    let group4Parent = filterList[3]?.value
      ? findNodeByName(groupTree, filterList[3]?.value, 3)
      : group3Parent;
    let group5Parent = filterList[4]?.value
      ? findNodeByName(groupTree, filterList[4]?.value, 4)
      : group4Parent;
    const filterOptions = {
      1: getSelectOptionsByName([groupTree], 1, filterList),
      2: getSelectOptionsByName(group2Parent, 2, filterList),
      3: getSelectOptionsByName(group3Parent, 3, filterList),
      4: getSelectOptionsByName(group4Parent, 4, filterList),
      5: getSelectOptionsByName(group5Parent, 5, filterList),
    };
    setFilterGroupOptions(filterOptions);
    for (let i = 2; i <= 5; i++) {
      if (_.some(filterOptions[i], { value: filterList[i]?.value }) === false) {
        setFilterList({ ...filterList, [i]: { value: null, label: "[ALL]" } });
      }
    }
  }, [filterList, groupTree]);

  const handleCheckDelete = (e, index) => {
    const data = [...departments];
    if (index !== undefined) {
      data[index].delete = !!e.target.checked;
    }
    setDepartments(data);
  };

  const updateSettings = async () => {
    try {
      const response = await updateUserSetting(
        filterList,
        USER_SETTING_CATEGORIES.DEPARTMENT_UPDATE
      );
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleChangeFilter = (e, name) => {
    setFilterList({
      ...filterList,
      [name]: e,
    });
  };

  const handleSubmitFilter = (e) => {
    setFilters({
      group_1: filterList[1]?.value,
      group_2: filterList[2]?.value,
      group_3: filterList[3]?.value,
      group_4: filterList[4]?.value,
      group_5: filterList[5]?.value,
      position: filterList["position"]?.value,
      user: filterList["user"]?.value,
    });
    updateSettings();
    setButtonLoading(DEPARTMENT_SEARCH_BUTTON);
  };

  const handleSort = (column) => {
    let currentOrder = changeOrder(orderList[column]);
    setOrderList({
      ...orderList,
      [column]: currentOrder,
    });
  };

  function handleChangeGroup(e, level) {
    const newData = { ...departmentModalData };
    newData[level] = e?.value;
    for (++level; level <= 5; level++) {
      newData[level] = null;
    }
    setDepartmentModalData(newData);
  }

  const handleChangePosition = (e) => {
    setDepartmentModalData({ ...departmentModalData, position: e?.value });
  };

  const handleChangeUsers = (e) => {
    const newUsers = e;
    setDepartmentModalData({ ...departmentModalData, users: newUsers });
  };

  const handleShowUpdateModal = (row) => {
    setIsAddModal(false);
    setFormError({});
    const users = row.users?.map((user) => {
      return { value: user.id, label: `${user.name}(${user.username})` };
    });
    setDepartmentModalData({
      id: row.id,
      1: row.group_1?.id ?? null,
      2: row.group_2?.id ?? null,
      3: row.group_3?.id ?? null,
      4: row.group_4?.id ?? null,
      5: row.group_5?.id ?? null,
      position: row.position?.id ?? null,
      users: users,
    });
    setShowModal(true);
  };

  const handleShowDeleteModal = (row) => {
    if (row) {
      setDeleteIds([row.id]);
      setButtonConfirmId(`button__delete-department--${row.id}`);
      setDeleteModal(true);
    } else {
      let deleteRows = _.filter(departments, (row) => row.delete === true);
      if (deleteRows.length > 0) {
        const ids = deleteRows.map((r) => r.id);
        setDeleteIds(ids);
        setButtonConfirmId(`button__delete-department--multiple`);
        setDeleteModal(true);
      }
    }
  };

  const handleSubmitDelete = (e) => {
    let ids = [...deleteIds];
    dispatch(setButtonProcessing(buttonConfirmId));
    deleteDepartment(ids)
      .then((response) => {
        setDeleteIds([]);
        setDeleteModal(false);
        setReload(reload + 1);
        dispatch(setAlertSuccess(response.message));
      })
      .catch((e) => {
        errorStatusHandle(e);
      })
      .finally(() => {
        dispatch(clearButtonProcessing(buttonConfirmId));
      });
  };

  const submitHandler = (e, buttonId) => {
    dispatch(setButtonProcessing(buttonId));
    let userIds = departmentModalData.users?.map((selected) => selected.value);
    const data = {
      id: departmentModalData.id,
      group_1: departmentModalData[1],
      group_2: departmentModalData[2],
      group_3: departmentModalData[3],
      group_4: departmentModalData[4],
      group_5: departmentModalData[5],
      position: departmentModalData.position,
      users: userIds,
    };
    submitDepartment(data, departmentModalData.id)
      .then((res) => {
        setFormError({});
        if (isAddModal) {
          setDepartmentModalData(initDepartmentData);
        }
        dispatch(setAlertSuccess(res.message));
        setShowModal(false);
        setReload(reload + 1);
      })
      .catch((e) => {
        if (e.status === 400) {
          setFormError({ ...e.data });
        }
        errorStatusHandle(e);
      })
      .finally(() => {
        dispatch(clearButtonProcessing(buttonId));
      });
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="部門マスタ更新" />
      <RedirectAlert />
      <PageAlert />
      <ButtonDPad />
      <div>
        <div id="filter-search" className="w-fit pr-6 mb-4">
          <FilterSearch
            onSubmit={handleSubmitFilter}
            id={DEPARTMENT_SEARCH_BUTTON}
          >
            {ArrayUtils.range(1, 5).map(
              (i) =>
                groupSettings[`group_${i}`].active && (
                  <FormGroup direction="vertical" className="pr-4" key={i}>
                    <label className="mb-[4px] font-medium whitespace-nowrap">
                      {groupSettings[`group_${i}`].name}
                    </label>
                    <FormGroupInput>
                      <Select2
                        nextFocus={
                          groupSettings[`group_${i + 1}`]?.active
                            ? `group_${parseInt(i + 1)}_id`
                            : "position_id"
                        }
                        name={`group_${i}`}
                        autoFocus={i === 1}
                        maxLength={30}
                        className="lg:min-w-[200px] min-w-[160px] lg:max-w-[240px] max-w-[228px]"
                        value={filterList[i]}
                        options={filterGroupsOptions[i]}
                        onChange={(e) => handleChangeFilter(e, i)}
                      />
                    </FormGroupInput>
                  </FormGroup>
                )
            )}
            <FormGroup direction="vertical" className="pr-4">
              <label className="lg:text-base text-[15px] mb-[4px] font-medium">
                職位
              </label>
              <FormGroupInput>
                <Select2
                  maxLength={50}
                  name="position"
                  nextFocus="user_id"
                  className="2xl:w-[200px] md:w-[150px]"
                  value={filterList["position"]}
                  options={positions}
                  onChange={(e) => handleChangeFilter(e, "position")}
                />
              </FormGroupInput>
            </FormGroup>
            <FormGroup direction="vertical" className="pr-4">
              <label className="lg:text-base text-[15px] mb-[4px] font-medium">
                ユーザー
              </label>
              <FormGroupInput>
                <Select2
                  maxLength={20}
                  name="user"
                  className="2xl:w-[200px] md:w-[150px]"
                  value={filterList["user"]}
                  options={users}
                  onChange={(e) => handleChangeFilter(e, "user")}
                />
              </FormGroupInput>
            </FormGroup>
          </FilterSearch>
        </div>
        <div id="table-container" className="min-w-full w-fit pr-6">
          <div className="rounded-lg border border-tenken-gray-300">
            <Table striped>
              <Table.Head>
                {ArrayUtils.range(1, 5).map(
                  (i) =>
                    groupSettings[`group_${i}`]?.active && (
                      <Table.HeadCell
                        key={i}
                        sortable
                        order={orderList[`group_${i}`]}
                        onChangeOrder={() => handleSort(`group_${i}`)}
                      >
                        <span
                          className="lg:text-base text-[15px] font-medium cursor-pointer"
                          onClick={() => handleSort(`group_${i}`)}
                        >
                          {groupSettings[`group_${i}`]?.name}
                        </span>
                      </Table.HeadCell>
                    )
                )}
                <Table.HeadCell>
                  <span className="lg:text-base text-[15px] font-medium cursor-pointer w-[176px]">
                    職位
                  </span>
                </Table.HeadCell>
                <Table.HeadCell className="min-w-[240px]">
                  <span className="lg:text-base text-[15px] font-medium cursor-pointer">
                    ユーザー
                  </span>
                </Table.HeadCell>
                <Table.HeadCell className="min-w-[120px]"></Table.HeadCell>
                <Table.HeadCell className="w-[96px] flex justify-center">
                  <ButtonTableBulkDelete
                    type="button"
                    onClick={() => handleShowDeleteModal()}
                  />
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="devide-y lg:text-base text-[15px] relative">
                <LoadingSpinner component="department_update" />
                {departments.map((row, idx) => (
                  <Table.Row
                    key={idx}
                    className={row.delete ? "!bg-[#FFE7E7]" : ""}
                  >
                    {ArrayUtils.range(1, 5).map(
                      (i) =>
                        groupSettings[`group_${i}`]?.active && (
                          <Table.Cell
                            key={i}
                            className="max-w-[240px] truncate"
                          >
                            <span title={row[`group_${i}`]?.name ?? "[ALL]"}>
                              {row[`group_${i}`]?.name ?? "[ALL]"}
                            </span>
                          </Table.Cell>
                        )
                    )}
                    <Table.Cell className="max-w-[176px] truncate">
                      <span title={row.position?.name}>
                        {row.position?.name}
                      </span>
                    </Table.Cell>
                    <Table.Cell>
                      {row.users.length < 2 ? (
                        <div className="max-w-[240px] truncate">
                          {row.users[0] ? (
                            <span
                              title={
                                row.users[0].name +
                                "(" +
                                row.users[0].username +
                                ")"
                              }
                            >
                              {row.users[0].name}({row.users[0].username})
                            </span>
                          ) : (
                            "－"
                          )}
                        </div>
                      ) : (
                        <ExpandableDiv
                          expandable={true}
                          expanded={expanded}
                          setExpanded={setExpanded}
                          id={row.id}
                          className="w-full -ml-4 max-w-[280px]"
                        >
                          {pushToFirst(
                            filterList.user?.value,
                            row.users,
                            "id"
                          ).map((u, i) => {
                            return (
                              <div key={i}>{`${u.name}(${u.username})`}</div>
                            );
                          })}
                        </ExpandableDiv>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      <div className="flex justify-center align-center">
                        <ButtonTableEdit
                          className="mr-[8px]"
                          onClick={() => handleShowUpdateModal(row)}
                        />
                        <ButtonTableDelete
                          onClick={() => handleShowDeleteModal(row)}
                        />
                      </div>
                    </Table.Cell>
                    <Table.Cell className="text-center w-[96px]">
                      <CheckboxInput
                        position="justify-center"
                        checked={row.delete}
                        onChange={(e) => handleCheckDelete(e, idx)}
                        value={row.id}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          <div className="w-full md:mt-3 xl:mt-6">
            <div className="xl:flex xl:items-center xl:space-x-2">
              <ButtonAdd
                onClick={() => {
                  setDepartmentModalData(initDepartmentData);
                  setFormError({});
                  setIsAddModal(true);
                  setShowModal(true);
                }}
              >
                <span className="lg:text-base text-[15px]">新規追加</span>
              </ButtonAdd>
              <div className="xl:mt-0 mt-3 w-full">
                <Pagination
                  setPage={setPage}
                  currentPage={page}
                  pageSize={perPage}
                  setPageSize={setPerPage}
                  totalCount={count}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          dismissiable
          size="2xl"
        >
          <Modal.Header className="">
            {isAddModal ? "新しい部門マスタを追加する" : "部門マスタを更新"}
          </Modal.Header>
          <Modal.Body className="overflow-y-auto">
            <PageAlert />
            <div className="">
              {ArrayUtils.range(1, 5).map(
                (i) =>
                  groupSettings[`group_${i}`]?.active && (
                    <FormGroup key={i}>
                      <Label className="whitespace-nowrap w-[244px]">
                        {groupSettings[`group_${i}`]?.name}
                      </Label>
                      <FormGroupVerticalInput
                        error={getInputErrorMessage(
                          formError.errors,
                          "group_" + i
                        )}
                      >
                        <Select2
                          className="w-[360px]"
                          value={SelectUtils.getSelectedValue(
                            groupsOptions[i],
                            departmentModalData[i],
                            false
                          )}
                          options={groupsOptions[i]}
                          onChange={(e) => handleChangeGroup(e, i)}
                          maxLength="30"
                          placeholder={groupSettings[`group_${i}`]?.name}
                        />
                      </FormGroupVerticalInput>
                    </FormGroup>
                  )
              )}
              <FormGroup>
                <Label className="whitespace-nowrap w-[244px]" required>
                  職位
                </Label>
                <FormGroupVerticalInput
                  error={getInputErrorMessage(formError.errors, "position")}
                >
                  <Select2
                    className="w-[360px]"
                    options={positions.slice(1)}
                    isClearable={true}
                    classNamePrefix="react-select"
                    value={SelectUtils.getSelectedValue(
                      positions.slice(1),
                      departmentModalData.position
                    )}
                    placeholder="職位"
                    onChange={(e) => handleChangePosition(e)}
                    maxLength="50"
                  />
                </FormGroupVerticalInput>
              </FormGroup>
              <FormGroup>
                <Label className="whitespace-nowrap w-[244px]" required>
                  ユーザー
                </Label>
                <FormGroupVerticalInput
                  error={getInputErrorMessage(formError.errors, "users")}
                >
                  <Select2
                    className="w-[360px]"
                    options={users.slice(1)}
                    isMulti
                    isClearable={true}
                    value={departmentModalData.users}
                    placeholder="ユーザー"
                    onChange={(e) => handleChangeUsers(e)}
                    maxLength="20"
                  />
                </FormGroupVerticalInput>
              </FormGroup>
            </div>
          </Modal.Body>
          <Modal.Footer className="space-x-[32px]">
            <div className="w-1/2">
              <Button
                color="light"
                className="w-full"
                onClick={() => setShowModal(false)}
              >
                閉じる
              </Button>
            </div>
            <div className="w-1/2">
              <Button
                color="primary"
                onClick={(e) => submitHandler(e, "button__create-department")}
                className="w-full"
                id="button__create-department"
              >
                {isAddModal ? "新規追加" : "更新"}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <ConfirmDeleteModal
          onConfirm={handleSubmitDelete}
          message={
            "続行すると、すべてのデータが削除され、復元できなくなります。このアイテムを削除してもよろしいですか？"
          }
          showModal={deleteModal}
          setShowModal={setDeleteModal}
          onCancel={() => setDeleteModal(false)}
          buttonConfirmId={buttonConfirmId}
        />
      </div>
    </BackendLayout>
  );
};

export default DepartmentUpdate;
